export const activate = {
  loading: 'Ładowanie',
  insufficientParams: 'Błędny link',
  insufficientParamsPara: 'Brak wymaganych paramterów',
  setPassword: 'Ustaw hasło użytkownika',
  savePassword: 'Zapisz hasło',
  goHome: 'Idź do Strony Głównej',
  notValidToken: 'Niepoprawny lub niekatywny token',
  alreadyVerified: 'Adres email został już zweryfikowany',
}
